<template v-slot:headerNav>
<div>
         <nav class="bg-white border-b border-gray-100">
      <!-- Primary Navigation Menu -->
      <div class="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
        <div class="flex justify-between h-8">
          <div class="flex">
            <!-- Navigation Links -->
            <div class="hidden space-x-8 sm:-my-px sm:flex">
               <jet-nav-link
          class="space-x-8"
                    :href="route('tc-integrates.index','tc')"
                    :active="route().current('tc-integrates.index','tc')"
                >
                    Excel
                </jet-nav-link>
             

               <jet-nav-link
                    class="ml-12 space-x-8"
                    :href="route('tc-templates.index','tc')"
                    :active="route().current('tc-templates.index','tc')"
                >
                    Template
                </jet-nav-link>

                    <jet-nav-link
                    class="ml-12 space-x-8"
                    :href="route('tc-configurations.index','tc')"
                    :active="route().current('tc-configurations.index',tc)"
                >
                    Settings
                </jet-nav-link>
            </div>

                          
          </div>


         
        </div>
      </div>

     
    </nav>
</div>
</template>

<script>
import JetNavLink from '@/Jetstream/NavLink.vue';

export default {
    components:{
        JetNavLink
    }
}
</script>

<style>

</style>